import backofficeService from '../../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getHardware(params) {
    return backofficeService.Api().get('api/getHardware', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  
  create(data) {
    return backofficeService.Api().post('api/purchase/create', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getAll() {
    return backofficeService.Api().get('api/purchase')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
}
